<template>

    <div v-for="(image, index) in this.images" v-show="this.active == index" class="extra-rounded img-fluid my-2 shop-item-image max-width" :style="{ backgroundImage: `url('/storage/${image.path}')` }" @click="Enlarge(index)"></div>

    <div v-if="this.images.length > 1">
        <div class="flex-x" style="justify-content: space-between;">
            <button type="button" class="btn btn-warning my-2" @click="PreviousImage()">
                <i class="fas fa-arrow-circle-left"></i> Previous
            </button>
            <button type="button" class="btn btn-warning my-2" @click="NextImage()">
                Next <i class="fas fa-arrow-circle-right"></i>
            </button>
        </div>
        <div class="container-fluid g-0 my-2">
            <div class="row">
                <div v-for="(image, index) in this.images" class="col-lg-4 col-xl-4 col-md-6 col-sm-6 col-6">
                    <img class="rounded img-fluid max-width" :class="{ highlighted: this.active == index }" :src='URL(image.path)' @click="GoToImage(index)">
                </div>
            </div>
        </div>
    </div>

    <div v-show="this.enlarge == true" class="image-modal">
        <h2 @click="this.Close()"><i class="fas fa-times"></i> Close</h2>
        <img class="extra-rounded img-fluid my-2 max-width" :src='this.URL(this.images[this.active].path)'>
        <div v-if="this.images.length > 1" class="flex-x" style="justify-content: space-between;">
            <button type="button" class="btn btn-warning previous-image-button" @click="PreviousImage()">
                <i class="fas fa-arrow-circle-left"></i> Previous
            </button>
            <button type="button" class="btn btn-warning next-image-button" @click="NextImage()">
                Next <i class="fas fa-arrow-circle-right"></i>
            </button>
        </div>
    </div>

</template>

<script>
export default {

    data () {
        return {
            images: [],
            active: 0,
            enlarge: false
        }
    },

    props: ['items'],

    created () {
        this.images = this.items;
    },

    methods: {

        URL ( path ) {
            return window.location.origin + '/storage/' + path;
        },

        GetActivePath () {
            return "url(" + window.location.origin + '/storage/' + this.images[this.active].path + ")";
        },

        NextImage () {
            this.active++;
            if ( this.active >= this.images.length ) this.active = 0;
        },

        PreviousImage () {
            this.active--;
            if ( this.active < 0 ) this.active = this.images.length - 1;
        },

        GoToImage (index) {
            this.active = index;
        },

        Enlarge (index) {
            this.active = index;
            this.enlarge = true;
        },

        Close () {
            this.enlarge = false;
        }

    }

}
</script>